import React from 'react'
import TopBar from '../Components/TopBar/TopBar'
import VerificationCodeNew from '../Components/VerificationCode/VerificationCodeNew'

const VerificationCodePageNew = () => {
  return (
    <div>
        <TopBar/>
        <VerificationCodeNew/>
    </div>
  )
}

export default VerificationCodePageNew